// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TJe4D","largestCol":"styles_largestCol__1Or43","smallestCol":"styles_smallestCol__297M6"};